<template>
    <div class="w-full border rounded-lg flex items-center" :class="classList">
        <icon-magnifying-glass class="h-4 w-4 text-gray-500 mr-2"></icon-magnifying-glass>
        <input type="text" v-model="searchText" placeholder="search" class="w-full outline-none text-sm text-gray-600">
    </div>
</template>

<script>
import IconMagnifyingGlass from "../icons/IconMagnifyingGlass.vue";
export default {
    name: "search",
    props: ["classList"],
    emits: ["on-search"],
    components: { IconMagnifyingGlass, },
    data() {
        return {
            searchText: "",
        };
    },
    watch: {
        searchText(newVal) {
            this.$emit('on-search', newVal);
        },
    },
    methods: {
        clearInput() {
            this.searchText = "";
        },
    },
}
</script>